const pathToCnMap = {
  index: "首页",
  detail: "内容详情",
  hotNews: "热点问题",
  patentService: "专利服务",
  patentAnalysis: "专利分析",
  expertResources: "专家资源",
  basicKnowledge: "基础知识",
  agencyService: "代理服务",
  activity: "内容详情",
  service: "内容详情",
  policy: "政策法规",
  news: "新闻速递",
  analysis: "分析报告",
  compete: "竞赛动态",
  lecture: "素养教育",
  consult: "相关咨询",

  informationCenter:'资讯中心',
  resourceNavigation: "成果展示",
  informationService: "知识产权学堂",
  wkt:'微课堂',
  // syxly:'素养训练营',
  cxsl:'讲座培训',
  kcjx:'课程教学',
  zsjs:'知识竞赛',
  fxbg:'分析报告',
  fwal:'服务成果',
  // ywyj:'业务研究',
  xwdt:'新闻公告',
  // tzgg:'通知',
  zygx:'资源共享',
  jszy:'检索资源',
  zxgz:'中心规章'
};

function getCurrentCrumb(path) {
  const paths = path.split("/").filter(Boolean); // 获取所有路径
  return paths.reduce((pre, cur) => {
    pre.push({
      name: pathToCnMap[cur],
      toRouter: cur,
    });
    return pre;
  }, []);
}
function getResolveCrumb(path, name) {
  const paths = path.split("/").filter(Boolean); // 获取所有路径
  return paths.reduce((pre, cur) => {
    if (cur === "index") {
      pre.push({
        name: name,
        toRouter: cur,
      });
    } else {
      pre.push({
        name: pathToCnMap[cur],
        toRouter: cur,
      });
    }
    return pre;
  }, []);
}

module.exports = {
  getCurrentCrumb,
  getResolveCrumb,
};
